// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"264":"commons","348":"component---src-pages-keynote-speaking-js","936":"component---src-pages-index-js"}[chunkId] + "-" + {"264":"86d8f77d0fd55932e3df","348":"80db47ad5c8d785c47cb","936":"5200c12ec04ed7bdce44"}[chunkId] + ".js";
};